/* Thin wrapper so recovery code paths (stale-chunk reloads) can be unit
   tested — jsdom's window.location is not stubbable. */
export const reloadPage = (): void => {
  window.location.reload();
};
